// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profileImage-module_profileImageContainer__tIVzU {
    display: inline-flex;
    cursor: pointer;
    align-items: center;
    position: relative;
}

.profileImage-module_profileImageContainer__tIVzU.profileImage-module_loading__kXyu0 {
    opacity: 0.4;
    cursor: default;
    pointer-events: none;
}

.profileImage-module_loader__FrPlc {
    position: absolute;
    z-index: 1;
    left: 4px;
}

.profileImage-module_loader__FrPlc.profileImage-module_medium__SLDmh {
    left: 24px;
}

.profileImage-module_webcamContainer__BbbpJ {
    & video {
        object-fit: cover;
        inline-size: 100%;
        block-size: auto;
        object-position: bottom center;
        height: 500px;
    }
}

.profileImage-module_image__Xiqup {
    object-fit: cover;
    inline-size: 100%;
    block-size: auto;
    object-position: bottom center;
    height: 500px;
}

.profileImage-module_buttonContainer__TLUhi {
    display: flex;
    justify-content: space-evenly;
    padding: 10px;
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Image/profile/profileImage.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,iBAAiB;QACjB,iBAAiB;QACjB,gBAAgB;QAChB,8BAA8B;QAC9B,aAAa;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,aAAa;AACjB","sourcesContent":[".profileImageContainer {\n    display: inline-flex;\n    cursor: pointer;\n    align-items: center;\n    position: relative;\n}\n\n.profileImageContainer.loading {\n    opacity: 0.4;\n    cursor: default;\n    pointer-events: none;\n}\n\n.loader {\n    position: absolute;\n    z-index: 1;\n    left: 4px;\n}\n\n.loader.medium {\n    left: 24px;\n}\n\n.webcamContainer {\n    & video {\n        object-fit: cover;\n        inline-size: 100%;\n        block-size: auto;\n        object-position: bottom center;\n        height: 500px;\n    }\n}\n\n.image {\n    object-fit: cover;\n    inline-size: 100%;\n    block-size: auto;\n    object-position: bottom center;\n    height: 500px;\n}\n\n.buttonContainer {\n    display: flex;\n    justify-content: space-evenly;\n    padding: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileImageContainer": `profileImage-module_profileImageContainer__tIVzU`,
	"loading": `profileImage-module_loading__kXyu0`,
	"loader": `profileImage-module_loader__FrPlc`,
	"medium": `profileImage-module_medium__SLDmh`,
	"webcamContainer": `profileImage-module_webcamContainer__BbbpJ`,
	"image": `profileImage-module_image__Xiqup`,
	"buttonContainer": `profileImage-module_buttonContainer__TLUhi`
};
export default ___CSS_LOADER_EXPORT___;
